"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplatesSelector = void 0;
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var MultiSelectCombobox_1 = __importDefault(require("Common/MultiSelectCombobox/MultiSelectCombobox"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var useAccountTemplates_1 = __importDefault(require("Common/Templates/useAccountTemplates"));
function TemplatesSelector(_a) {
    var selectedTemplates = _a.selectedTemplates, setSelectedTemplates = _a.setSelectedTemplates, className = _a.className, templatesFilter = _a.templatesFilter, errorMessage = _a.errorMessage, errorIds = _a.errorIds;
    var apiBaseUrl = (0, inversify_react_1.useInjection)("apiBaseUrl");
    var accountTemplates = (0, useAccountTemplates_1.default)(apiBaseUrl, {
        pageSize: "ALL",
        filter: __assign({ templatesWith: [], withCrmInfo: [], withUsers: [] }, templatesFilter),
    }).accountTemplates;
    var comboboxEntries = accountTemplates.data
        ? accountTemplates.data.map(function (t) { return ({ label: t.name, value: t._id, data: t }); })
        : undefined;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(kaleidoscope_1.Label, { className: "kl-select__label", element: "div", size: "s", long: true }, "Created from template"),
        comboboxEntries === undefined ? (react_1.default.createElement(kaleidoscope_1.Stack, { padding: "m" },
            react_1.default.createElement(kaleidoscope_1.Spinner, { primary: true }))) : (react_1.default.createElement(MultiSelectCombobox_1.default, { entries: comboboxEntries, selectedValues: selectedTemplates !== null && selectedTemplates !== void 0 ? selectedTemplates : [], setSelectedValues: setSelectedTemplates, label: "Search templates", placeholder: "Enter a template name", notFoundMessage: "Archived or deleted template", errorMessage: errorMessage, errorValues: errorIds, icon: react_1.default.createElement(icons_1.Template, null) }))));
}
exports.TemplatesSelector = TemplatesSelector;
